'use client';

import { useId } from 'react';

interface Props {
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  checked: boolean;
  'data-testid'?: string;
}

const className = (disabled: boolean) =>
  disabled
    ? 'accent-input-border-color opacity-45'
    : 'accent-input-border-color';

const Checkbox = ({ disabled = false, onChange, checked, ...props }: Props) => {
  const id = useId();

  return (
    <input
      disabled={disabled}
      id={id}
      className={className(disabled)}
      checked={checked}
      type="checkbox"
      onChange={(e) => onChange?.(e.currentTarget.checked)}
      {...props}
    ></input>
  );
};

export default Checkbox;
